import { connect } from "react-redux";
import Component from "./Parameters";

export default connect(
    null,
    ({ scp: { parameters }, alert: { silence } }) => ({ parameters, silence })
)(Component);
